export enum ApprovalStatus {
  APPROVED = 0,
  REJECTED,
  PENDING,
  NOT_ARRIVED,
}

export const ApprovalStatusMap = {
  [ApprovalStatus.APPROVED]: '已通过',
  [ApprovalStatus.REJECTED]: '已驳回',
  [ApprovalStatus.PENDING]: '待审批',
  [ApprovalStatus.NOT_ARRIVED]: '未到达',
};

export const ApprovalStatusColorMap = {
  [ApprovalStatus.APPROVED]: '#00B578',
  [ApprovalStatus.REJECTED]: '#FF3141',
  [ApprovalStatus.PENDING]: '#999999',
  [ApprovalStatus.NOT_ARRIVED]: '#999999',
};

export const StepStatusMap = {
  [ApprovalStatus.APPROVED]: 'finish',
  [ApprovalStatus.REJECTED]: 'error',
  [ApprovalStatus.PENDING]: 'process',
  [ApprovalStatus.NOT_ARRIVED]: 'wait',
};
